"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {

    props: ["slide"],

    computed: {
        cover: function cover() {
            // TODO get in dico
            // return require("assets/tmp/" + this.img)
        },
        description: function description() {
            if (this.slide.description && this.slide.description.length > 85) return this.slide.description.substring(0, 84) + "...";
            return this.slide.description;
        },
        month: function month() {
            return this.slide.date.format("MMM").replace(".", "");
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"presets":["es2015","stage-0"],"plugins":["transform-class-properties","transform-function-bind"]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/slider/slide-instagram/SlideInstagramComponent.vue
// module id = 404
// module chunks = 0